import { BaseService } from "core/services";
import WoundDressingRouteService from "./WoundDressingRouteService";

class WoundDressingService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new WoundDressingRouteService());
    }

    createAdditionalValidations(resource) {
        const url = this.routeService.createAdditionalValidations(resource);
        return this.apiClient.post(url, resource);
    }

    getValidationCheck(resource) {
        const url = this.routeService.getValidationCheck(resource);
        return this.apiClient.post(url, resource);
    }
}

export default WoundDressingService;
